export default __webpack_public_path__ + "static/media/mapMarkerAttraction.80971547.svg";